import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

import { MsalService } from 'src/app/core/msal';
import { Languages } from '../../models/languageModel/languages';
import { Language } from '../../models/languageModel/language';
import { UtilService } from 'src/app/core/services/util.service';
import { AccessControlService } from 'src/app/core/services/accessControl.service';
import { NotificationLocalModel } from 'src/app/models/notificationModel/NotificacionModelLocal';
import { interval } from 'rxjs';
import { timeInterval } from 'rxjs/operators';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  languages = new Languages();
  languaje: Language = {name: '', code: ''}
  username: string;
  languageSelected: boolean;

  showNotification = false;
  
  public SEC: boolean = false;
  public STB: boolean = false;
  public Directory: boolean = false;

  public notifications = Array<NotificationLocalModel>();
  public notificationsEs: NotificationLocalModel[] = null;
  public notificationsEn: NotificationLocalModel[] = null;

  constructor(private translate: TranslateService, 
              private authService: MsalService,
              private utilService: UtilService,
              private accessControlService: AccessControlService,
              private notificationservice: NotificationService) { }

  ngOnInit(): void {
    this.getUserRoles();

    this.username = localStorage.getItem('username');

    if(localStorage.getItem('languaje') == undefined)
    {
      this.onClick(this.languages.data[0]);
    }
    else{
      var localLanguage = localStorage.getItem('languaje');
      this.onClick(JSON.parse(localLanguage));
    }

    this.getNotifications();
    const seconds = interval(900000);
    seconds.pipe(timeInterval()).subscribe(R =>
      this.getNotifications()
    );

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadNotificationsByLanguageCode(event.lang);
    });
  }

  onClick(lang){
    if(lang.name == 'Español')
    {
      this.translate?.use(lang.code);
      this.languageSelected = false;
    }
    else{
      this.translate?.use(lang.code);
      this.languageSelected = true;
    }
    this.languaje = lang;
    localStorage.setItem('languaje', JSON.stringify(this.languaje));
  }

  getUserName() {
    return localStorage.getItem("name");
  }

  handlerCloseSession(){
    this.authService.logout();
  }

  handlerNotification() {
    if(this.notifications?.length > 0) {
      this.showNotification = !this.showNotification;

      this.utilService.setStatus(this.showNotification);
    }
  }

  async getUserRoles(){
    
    this.accessControlService.checkItHasRoles().subscribe(resp => {
      setTimeout(() => {
        this.setUserRoles();
      }, 1000);
    });
  }

  async setUserRoles(){

    let roles = this.accessControlService.getRoles();

    if(roles.length == 0 ) {
      this.accessControlService.roles$.subscribe(role => {
        if(role.includes('SEC_Minutes_Officer') || role.includes('SEC_Minutes_Officers')) {
          this.STB = true;
        } else if(role.includes('Recording Searchers')) {
          this.SEC = true;
        } else if(role.includes('directory')) {
          this.Directory = true;
        }
      })

    } else {
      if(roles.includes('SEC_Minutes_Officer') || roles.includes('SEC_Minutes_Officers')) {
        this.STB = true;
      } else if(roles.includes('Recording Searchers')) {
        this.SEC = true;
      } else if(roles.includes('directory')) {
        this.Directory = true;
      }
    }
  }

  getNotifications(){

    this.notificationservice.getNotRead(localStorage.getItem("username")).subscribe(resp =>{
      this.notificationsEs = Array<NotificationLocalModel>();
      this.notificationsEn = Array<NotificationLocalModel>();
      resp.data.forEach(element => {
        this.notificationsEs.push({
          id: element.notificationId,
          text: element.textEs
        });
        this.notificationsEn.push({
          id: element.notificationId,
          text: element.textEn
        });
      });

      let currentlangua: Language = JSON.parse(localStorage.getItem("languaje"));
      this.loadNotificationsByLanguageCode(currentlangua.code);

    }, (error) => {
      // this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  loadNotificationsByLanguageCode(languageCode: string){
    if (languageCode == 'es') {
      this.notifications = this.notificationsEs;
    }
    else{
      this.notifications = this.notificationsEn;
    }
  }
}
